import React, { useEffect, useState } from 'react';
import KTable from '../../components/KTable';
import AssignGridFilter from '../../filters/AssignGridFilter';
import KPagination from '../../components/KPagination';
import { Label } from 'reactstrap';
import classNames from 'classnames';
import AssignGridModal from '../modals/AssignGridModal';
import {
  assignGridSelector,
  getRegisteredEmployees,
  updateSelectedCandidate,
} from '../../features/assignGridSlice';
import {
  AssignGridDataType,
  AssignGridFilterType,
  LoggedUserType,
  UserType,
} from '../../utils/Types';
import {
  AssignGridColumnHeader,
  getAssignGridDataRequest,
} from './AssignGridHelper';
import CenterSpinner from '../../components/CenterSpinner';
import { DEFAULT_PAGE_SIZE } from '../../utils/Constant';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { loginSelector } from '../../features/loginSlice';
import ToggleSwitch from '../../components/ToggleSwitch';
import { useLoader } from '../../loader/LoaderProvider';

const AssignGridPage: React.FunctionComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [initModal, setInitModal] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const dispatch = useAppDispatch();
  const assignGridData: AssignGridDataType[] =
    useAppSelector(assignGridSelector).assignGridData?.result;
  const pagination =
    useAppSelector(assignGridSelector).assignGridData.pagination;
  const { showLoader, setShowLoader } = useLoader();
  const [selectedUser, setSelectedUser] = useState<AssignGridDataType | null>();
  const [selectedFilter, setSelectedFilter] = useState<any>({});
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;
  const [showFilter, setShowFilter] = useState<boolean>(true);

  /**
   * Find assign grid list data form server.
   */
  const getAssignGridData = () => {
    try {
      dispatch(
        getRegisteredEmployees(
          getAssignGridDataRequest(
            selectedFilter,
            pageSize,
            currentPage,
            userDetails,
            user
          )
        )
      )
        .unwrap()
        .then(() => {
          if (!isModalOpen) {
            setShowLoader(false);
          }
        });
      setShowLoader(true);
    } catch (err) {}
  };

  useEffect(() => {
    if (assignGridData && assignGridData.length > 0 && !isModalOpen) {
      setShowLoader(false);
    }
  }, [assignGridData]);

  useEffect(() => {
    if (userDetails?.roleid) getAssignGridData();
  }, [pageSize, currentPage, selectedFilter, user, userDetails]);

  const applyFilters = (assignFilter: AssignGridFilterType) => {
    setCurrentPage(1);
    setSelectedFilter(assignFilter);
  };
  /**
   * Update show hide status of popup
   */
  const toggleModal = () => {
    dispatch(updateSelectedCandidate({}));
    if (isModalOpen) {
      setSelectedUser(null);
      getAssignGridData();
      setTimeout(() => {
        setInitModal(!initModal);
      }, 500);
    } else {
      setInitModal(!initModal);
    }
    setIsModalOpen(!isModalOpen);
  };

  const handleToggleSwitch = () => {
    setShowFilter((prev) => !prev);
  };

  return (
    <div>
      <Label className="text-heading">Assign Grid</Label>
      <ToggleSwitch isOpen={showFilter} onClick={handleToggleSwitch} />

      <div className="task-item-parent-view">
        {showFilter && <AssignGridFilter onApplyFilters={applyFilters} />}
        <div className="mt-4">
          <KTable
            data={assignGridData}
            tableParentClass={classNames('table-parent-assign-grid', {
              hideFilters: !showFilter,
            })}
            columnHeader={AssignGridColumnHeader}
            isLoading={showLoader}
            onAction={(param: any) => {
              // change to candidateId
              setSelectedUser(param);
              toggleModal();
            }}
          />
          {assignGridData && assignGridData.length > 0 && (
            <KPagination
              totalPages={pagination?.totalPages}
              currentPage={pagination?.currentPage}
              pageSize={pagination?.pageSize}
              onPageChange={setCurrentPage}
              onSizeChange={setPageSize}
              fromItem={pagination.fromItem}
              toItem={pagination.toItem}
              totalItems={pagination?.totalItems}
            />
          )}
        </div>
      </div>
      {initModal && (
        <AssignGridModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          candidateId={selectedUser?.candidateid}
          assignedgrids={selectedUser?.assignedgrids}
          pincode={selectedUser?.pincode}
          selectedUser={selectedUser}
          refreshData={getAssignGridData}
        />
      )}

      {!isModalOpen && (
        <CenterSpinner showLoader={showLoader} className="spinner-60" />
      )}
    </div>
  );
};

export default AssignGridPage;
